import { makeStyles } from '@material-ui/core/styles'
import { pageVars } from '../../../../../pages/const/pageVars'
import FirstMessageTop from './FirstMessageTop'

const { SERVICES, SKILLSETS, LOCATIONS } = pageVars

const viewDataPages = [
  SERVICES.codeText,
  SKILLSETS.codeText,
  LOCATIONS.codeText
]

const removeUndesiredWords = (str) => {
  const wordsToRemove = ['Assigned', 'Number of']

  let result = str
  wordsToRemove.forEach((word) => {
    if (result.includes(word)) result = result.replace(word, '')
  })

  return result
}

const FirstModalMessage = ({ type, pageCodeText, viewDataItems }) => {
  const classes = useStyles()

  const dataOrganized = {}
  viewDataItems?.length &&
    viewDataItems.forEach((item) => {
      dataOrganized[item.label]
        ? (dataOrganized[item.label] =
            Number(item.value) + dataOrganized[item.label])
        : (dataOrganized[item.label] = Number(item.value))
    })

  const wordings = {
    noun:
      (type === 'suspension' && 'suspension') ||
      (type === 'activation' && 'activation') ||
      (type === 'deletion' && 'deletion'),
    gerund:
      (type === 'suspension' && 'suspending') ||
      (type === 'activation' && 'activating') ||
      (type === 'deletion' && 'deleting'),
    topVerb:
      (type === 'suspension' && 'suspend') ||
      (type === 'activation' && 'activate') ||
      (type === 'deletion' && 'flag for deletion')
  }

  return (
    <span className={`${classes.flexCenter} ${classes.root}`}>
      <FirstMessageTop 
        operationWordingVerb={wordings['topVerb']} 
        pageNameSingular={pageVars[pageCodeText].singular}
      />
      <span className={`${classes.flexCenter} ${classes.bottom}`}>
        <span className={classes.warning}>WARNING!</span>
        {/* Not Available for services and skillsets */}
        {!viewDataPages.includes(pageCodeText) && (
          <>
            <span>
              By flagging selected {pageVars[pageCodeText].singular} for {wordings['noun']} you are also
            </span>
            <span>
              {wordings['gerund']} data connection associated only to the account.
            </span>
            {!!viewDataItems?.length && (
              <span className={classes.associatedItems}>
                <span>Associated data for {wordings['noun']}:</span>
                <span className={classes.flexCenter}>
                  {Object.keys(dataOrganized).map(
                    (key, idx) =>
                      !!Number(dataOrganized[key]) && (
                        <span key={`${key}${idx}`}>
                          {`${dataOrganized[key]} ${removeUndesiredWords(key)}`}
                        </span>
                      )
                  )}
                </span>
              </span>
            )}
          </>
        )}
        {/*  */}
        <span>
          After {wordings['gerund']} selected {pageVars[pageCodeText].singular} and its data connections,{' '}
        </span>
        <span>
          for {wordings['noun']}, data will{' '}
          {['suspension', 'deletion'].includes(type) && 'not'} be searchable and
          visible in the application
        </span>
      </span>
    </span>
  )
}

export default FirstModalMessage

const useStyles = makeStyles((theme) => ({
  flexCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  root: {
    width: '100%',
    height: '100%',
    ...theme.typography.p,
    color: theme.palette.tertiary.main
  },
  top: {
    width: '100%',
    height: '100%',
    ...theme.typography.p,
    color: theme.palette.tertiary.main,
    padding: '0 0 20px 0'
  },
  warning: {
    color: 'red',
    padding: '0 0 10px 0'
  },
  bottom: {
    border: `1px solid ${theme.palette.quaternary.accent}`,
    borderRadius: '10px',
    padding: '10px',
    width: '100%',
    height: '100%',
    ...theme.typography.h6,
    color: theme.palette.tertiary.main
  },
  associatedItems: {
    padding: '10px 0'
  }
}))
